import { toast } from 'react-toastify';

// Components
import Text from 'components/common/Text';

const ToastManager = {

	show(text, webConfig, type, config = {}) {

	const defaultConfig = {
		duration: 5000,
		className: 'custom-toast',
		style: { 
            padding: '10px 20px',
            height: 'auto',
			right: 0,
			transform: 'translateX(15px)'
		},
	};

	const toastId = toast(
			<div 
				style={{
					color: 'black',
					fontWeight: '500',
					textAlign: webConfig.dir === 'rtl' ? 'right' : 'left',
					fontSize: '15px',
                    width: '100%',
                    height: 'auto',
                    fontFamily: webConfig.fontFamily,
					direction: webConfig.dir,
				}}
			>
				{text}
			</div>
		, 
		{ ...defaultConfig, ...config })
	},
};

export default ToastManager;